// George Mason University's bachelor's majors (#2739). Read on 2026-10-01
// from the official 2026-2027 University Catalog's program list
// (catalog.gmu.edu/programs): every program the catalog types "Bachelor's",
// grouped by the college or school the catalog assigns it to, with the degree
// as the catalog writes it. Minors, certificates (one graduate certificate the
// list also tags Bachelor's is left out), bachelor's/accelerated master's
// pairings, dual degrees, concentrations and graduate programs are left out.
// Environmental and Sustainability Studies, BA appears twice in the catalog,
// once in Humanities and Social Sciences and once in Science, and is listed
// under both.
const majors = {
    "slug": "george-mason-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in George Mason's official 2026-2027 University Catalog, by college or school. Minors, certificates, concentrations and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "George Mason University Catalog 2026-2027, Programs",
                "url": "https://catalog.gmu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Inclusive Early Childhood Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Recreation Management",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Special Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                },
                {
                    "name": "Tourism and Events Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering and Computing",
            "source": {
                "label": "George Mason University Catalog 2026-2027, Programs",
                "url": "https://catalog.gmu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Applied Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil and Infrastructure Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Cyber Security Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Systems and Industrial Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Humanities and Social Sciences",
            "source": {
                "label": "George Mason University Catalog 2026-2027, Programs",
                "url": "https://catalog.gmu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BFA"
                },
                {
                    "name": "Criminology, Law and Society",
                    "degree": "BA"
                },
                {
                    "name": "Criminology, Law and Society",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental and Sustainability Studies",
                    "degree": "BA"
                },
                {
                    "name": "Foreign Languages",
                    "degree": "BA"
                },
                {
                    "name": "Global Affairs",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BA"
                },
                {
                    "name": "Individualized Study",
                    "degree": "BIS"
                },
                {
                    "name": "Integrative Studies",
                    "degree": "BA"
                },
                {
                    "name": "Integrative Studies",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Russian and Eurasian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Public Health",
            "source": {
                "label": "George Mason University Catalog 2026-2027, Programs",
                "url": "https://catalog.gmu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Community Health",
                    "degree": "BS"
                },
                {
                    "name": "Health Administration",
                    "degree": "BS"
                },
                {
                    "name": "Health Informatics",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "George Mason University Catalog 2026-2027, Programs",
                "url": "https://catalog.gmu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Astronomy",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Computational and Data Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Sustainability Studies",
                    "degree": "BA"
                },
                {
                    "name": "Forensic Science",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Visual and Performing Arts",
            "source": {
                "label": "George Mason University Catalog 2026-2027, Programs",
                "url": "https://catalog.gmu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Art and Visual Technology",
                    "degree": "BA"
                },
                {
                    "name": "Art and Visual Technology",
                    "degree": "BFA"
                },
                {
                    "name": "Computer Game Design",
                    "degree": "BFA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Film and Video Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Theater",
                    "degree": "BA"
                },
                {
                    "name": "Theater",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "Costello College of Business",
            "source": {
                "label": "George Mason University Catalog 2026-2027, Programs",
                "url": "https://catalog.gmu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Business",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Jimmy and Rosalynn Carter School for Peace and Conflict Resolution",
            "source": {
                "label": "George Mason University Catalog 2026-2027, Programs",
                "url": "https://catalog.gmu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Conflict Analysis and Resolution",
                    "degree": "BA"
                },
                {
                    "name": "Conflict Analysis and Resolution",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Schar School of Policy and Government",
            "source": {
                "label": "George Mason University Catalog 2026-2027, Programs",
                "url": "https://catalog.gmu.edu/programs/"
            },
            "majors": [
                {
                    "name": "International Security and Law",
                    "degree": "BA"
                },
                {
                    "name": "Political Science and International Politics",
                    "degree": "BA"
                },
                {
                    "name": "Public Administration",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Interdisciplinary Programs",
            "source": {
                "label": "George Mason University Catalog 2026-2027, Programs",
                "url": "https://catalog.gmu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Applied Science",
                    "degree": "BAS"
                }
            ]
        }
    ]
};

export default majors;
